import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Button from '../../../../shared/_TBComponents/Button';
import Modal from '../../../../shared/_TBComponents/Modal';
import Text from '../../../../shared/_TBComponents/Text';
import AthleteProgramForm from './AthleteProgramForm';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  gap: 10px;
`;

const Footer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const AddProgramModal = ({
  isOpen,
  onClose,
  programs,
  athletePrograms,
  onSave,
}) => {
  const isAssigningPrograms = useSelector(
    (state) => state.navigator.ui.isAssigningAthletePrograms,
  );
  const [programsToAssign, setProgramsToAssign] = useState([]);

  const handleClose = () => {
    setProgramsToAssign([]);
    onClose();
  };

  const getSaveLabel = () => {
    if (isAssigningPrograms) return 'Assigning...';
    const count = programsToAssign.length;
    if (count === 1) return 'Assign Program';
    return count > 1 ? `Assign ${count} Programs` : 'Assign Program';
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      customBorderRadius='8px'
      customPadding='24px'
      customMaxWidth='650px'
      customMinHeight='500px'
      overlayBackgroundColor='rgba(0, 0, 0, 0.75)'
    >
      <ContentWrapper>
        <Text styledTextProps={{ fontSize: '18px', fontWeight: 600, marginBottom: '0' }}>
          Add Program Assignments
        </Text>
        <AthleteProgramForm
          athletePrograms={athletePrograms}
          programs={programs}
          addProgramMode
          onSelectionChange={(ids) => setProgramsToAssign(ids)}
          onOpenNestedModal={() => {}}
        />
        <Footer>
          <Button
            name='Cancel'
            fontSize='14px'
            txtColor='#757575'
            bgColor='#FFF'
            borderColor='#EEEEEE'
            customBorderRadius='6px'
            styledTextProps={{ fontWeight: 600 }}
            onClick={(e) => { e.preventDefault(); handleClose(); }}
          />
          <Button
            name={getSaveLabel()}
            fontSize='14px'
            txtColor='#FFF'
            bgColor='#444444'
            borderColor='#444444'
            customBorderRadius='6px'
            styledTextProps={{ fontWeight: 600 }}
            disabled={programsToAssign.length === 0 || isAssigningPrograms}
            onClick={(e) => { e.preventDefault(); onSave(programsToAssign); }}
          />
        </Footer>
      </ContentWrapper>
    </Modal>
  );
};

AddProgramModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  programs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    programName: PropTypes.string,
  })).isRequired,
  athletePrograms: PropTypes.arrayOf(PropTypes.shape({})),
  onSave: PropTypes.func.isRequired,
};

AddProgramModal.defaultProps = {
  athletePrograms: [],
};

export default AddProgramModal;
